import vars from '../helpers';

const init = () => {
	const $menu = $('.js-menu');
	const $menuEndPoint = $('.js-menu-end-point');
	const $sections = $('.js-section');
	const $items = $('.js-menu-item');

	let isFixed = false;
	let menuPosition = false;
	let isAbsolute = false;
	let isShown = false;
	let active = 0;

	vars.$window.on('scroll resize', () => {
		const windowScrollTop = Math.floor(vars.$window.scrollTop());

		$sections.each((i, section) => {
			const $section = $(section);

			let offsetY;

			if (vars.isMobile()) {
				offsetY = Math.floor($('.js-title[data-target="1"]').height() * 3);
			} else {
				offsetY = Math.floor($('.js-title[data-target="1"]').height());
			}

			const sectionOffsetTop = Math.floor($section.offset().top) - offsetY;

			const setActiveItem = () => {
				active = +$section.data('num');
				$items.removeClass('isActive');

				$items.each((j, item) => {
					if ($(item).data('target') === active) {
						$(item).addClass('isActive');
					}
				});

				// console.log(sectionOffsetTop, offsetY);
			};

			if (windowScrollTop > sectionOffsetTop && +$section.data('num') > active) {
				setActiveItem();
			}

			if (windowScrollTop < sectionOffsetTop + Math.floor($section.height()) && +$section.data('num') < active) {
				setActiveItem();
			}
		});

		if (!vars.isMobile()) {
			// Логика по верхней точке
			const menuOffsetTop = Math.floor($menu.offset().top);
			const menuGutterTop = Math.floor(+$menu.height() / 2);

			if (windowScrollTop > menuOffsetTop - menuGutterTop && !isFixed) {
				$menu.css({
					position: 'fixed',
					top: `${menuGutterTop}px`,
				});

				isFixed = true;
				menuPosition = menuOffsetTop - menuGutterTop;
			}

			if (windowScrollTop < menuPosition && isFixed) {
				$menu.attr('style', '');

				isFixed = false;
				menuPosition = false;
			}

			// Логика по нижней точке
			const menuEndPointOffsetBottom = Math.floor($menuEndPoint.offset().top + $menuEndPoint.height()); // eslint-disable-line

			if (windowScrollTop > menuEndPointOffsetBottom - menuGutterTop * 2 && !isAbsolute) {
				$menu.css({
					position: 'absolute',
					top: `${menuEndPointOffsetBottom - menuGutterTop}px`, // stylelint-disable-line
				});

				isAbsolute = true;
			}

			if (windowScrollTop < menuEndPointOffsetBottom - menuGutterTop * 2 && isAbsolute) {
				$menu.css({
					position: 'fixed',
					top: `${menuGutterTop}px`,
				});

				isAbsolute = false;
			}
		} else {
			const menuOffsetTop = Math.floor($('.js-home-intro').height());

			if (windowScrollTop > menuOffsetTop && !isShown) {
				$menu.addClass('isShown');
				isShown = true;
			}

			if (windowScrollTop <= menuOffsetTop && isShown) {
				$menu.removeClass('isShown');
				isShown = false;
			}
		}
	});

	$('.js-menu-burger-button').on('click', () => {
		$menu.toggleClass('isOpen');
	});
};

export default {
	init,
};
